module.exports = __webpack_public_path__ + "img/FreelancerPeopleTablet.cfc6aaf7.webp";